/** Avoid "SS SS 9" when ss_code already includes SS. */
export function formatSsLabel(ssCode) {
  const raw = String(ssCode || '').trim();
  if (!raw) return '';
  if (/^ss\b/i.test(raw)) return raw;
  return `SS ${raw}`;
}
